import axios, { AxiosError } from "axios";
import { API_URL} from "../constant";

export async function api_practice_states() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getPracticeState`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_policy_type() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getPolicyType`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_companies() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getInsuranceCompany`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_ll_requested() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getllRequested`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_get_from_addrs() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getContactAboutUs`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_get_employee_type() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getEmployeeType`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

export async function api_get_schools() {

    try {
        const response = await axios.get(
            `${API_URL}api/info/getSchool`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    } catch (err) {
        return [];
    }
}
